module.exports = __webpack_public_path__ + "img/Debate_workshop.088079a5.png";